import React, {useEffect, useState} from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle, Grid2, MenuItem} from "@mui/material";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import {OrderAdminDTO, OrderStatus} from "../SocietyAdminOrders";
import CustomTextField from "../../../customMUIComponents/CustomTextField";
import useDataPut from "../../../../hooks/useDataPut";
import {ProductDTO} from "../../societyAdminArticles/societyAdminArticlesList/SocietyAdminArticlesList";


interface AdminOrderLifecycleModalProps {
    open: boolean,
    setOpen: (open: boolean) => void,
    order: OrderAdminDTO,
}

const STATUS_KEY_TO_TEXT_MAP = new Map<OrderStatus, string>([
    ["NEW", "A traiter"],
    ["SHIPPED", "Expédié"],
    ["COMPLETED", "Livré"],
]);

const AdminOrderLifecycleModal = ({open, setOpen, order}: AdminOrderLifecycleModalProps) => {

    const {putDataPromise} = useDataPut<OrderAdminDTO>(`/societies/${order.societyId}/orders/${order.id}`, {}, true, false, false);

    const [newStatus, setNewStatus] = useState<OrderStatus>(order.status);

    const updateStatus = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        putDataPromise(undefined, {
            status: newStatus
        }).then((response) => {
            window.location.reload();
        })
    }

    const handleCloseModal = () => {
        setNewStatus(order.status);
        setOpen(false);
    }

    useEffect(() => {
        setNewStatus(order.status)
    }, [open]);

    return (
        <>
            <form onSubmit={(e) => updateStatus(e)}>
                <Dialog
                    disablePortal
                    open={open}
                    onClose={() => setOpen(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <DialogTitle>
                        <Typography variant={"secondVariant"} fontSize={{xs: 18, sm: 20, md: 22}}>
                            Commande #{order.id} {order.firstname} {order.lastname}
                        </Typography>
                    </DialogTitle>
                    <DialogContent sx={{
                        minWidth: '300px'
                    }}>
                        <Grid2 container>
                            <Grid2 size={12} mt={2} pb={2}>
                                {order.status === 'NEW' && (
                                    <Typography
                                        variant={"secondVariant"}
                                    >
                                        Il s'agit d'une nouvelle commande à traiter. Mettez-la à jour ci-dessous une
                                        fois traitée. Un mail de confirmation sera envoyé au client.
                                    </Typography>
                                )}

                                {order.status === 'SHIPPED' && (
                                    <Typography
                                        variant={"secondVariant"}
                                    >
                                        Cette commande a été expédiée par vos soins. Mettez-là à jour ci-dessous si
                                        nécessaire.
                                    </Typography>
                                )}

                                {order.status === 'COMPLETED' && (
                                    <Typography
                                        variant={"secondVariant"}
                                    >
                                        Cette commande a été livrée par vos soins. Si ce n'est pas le cas, mettez-là à
                                        jour ci-dessous ci nécessaire.
                                    </Typography>
                                )}
                            </Grid2>
                            <Grid2 size={12} mt={2}>
                                <CustomTextField
                                    variant={"outlined"}
                                    value={newStatus || ''}
                                    label={"Statut de la commande"}
                                    setField={(fieldValue) => setNewStatus(fieldValue)}
                                    select
                                    selectOptions={Array.from(STATUS_KEY_TO_TEXT_MAP.entries()).map(([key, value]) => {
                                        return (
                                            <MenuItem key={key} value={key}>{value}</MenuItem>
                                        )
                                    })}
                                    mb={4}
                                    textAlign={"left"}
                                    required
                                />
                            </Grid2>
                        </Grid2>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            type={"submit"}
                        >
                            Mettre à jour
                        </Button>
                        <Button onClick={() => handleCloseModal()}>Fermer</Button>
                    </DialogActions>
                </Dialog>
            </form>
        </>
    );
}

export default AdminOrderLifecycleModal